export default "__VITE_ASSET__CtdPTIe$__"